/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehousePackageOrderItemDTO interface.
 */
export function instanceOfWarehousePackageOrderItemDTO(value) {
    return true;
}
export function WarehousePackageOrderItemDTOFromJSON(json) {
    return WarehousePackageOrderItemDTOFromJSONTyped(json, false);
}
export function WarehousePackageOrderItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'] == null ? undefined : json['title'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
    };
}
export function WarehousePackageOrderItemDTOToJSON(json) {
    return WarehousePackageOrderItemDTOToJSONTyped(json, false);
}
export function WarehousePackageOrderItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'asin': value['asin'],
        'imageUrl': value['imageUrl'],
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
    };
}
